export const getExerciseLength = (exercise?: ExerciseEntity) => {
    if (exercise?.exercise_type === 'highlight')
        return exercise.highlight_data.length;

    if (exercise?.exercise_type === 'video') {
        return 1;
    }

    if (
        exercise?.words.length &&
        !exercise.use_categories &&
        !exercise?.answer_button
    )
        return exercise.words.length;

    if (
        exercise?.sentences?.length &&
        !exercise.use_categories &&
        !exercise?.answer_button
    )
        return exercise.sentences.length;

    const words: number[] = [];
    exercise?.categories.forEach((c) =>
        c.words.forEach((w) => words.push(w.id))
    );

    return (
        words
            // filter duplicates
            .filter((v, i, a) => a.findIndex((t) => t === v) === i).length
    );
};
